
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/location-based-terms",
      function () {
        return require("private-next-pages/location-based-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/location-based-terms"])
      });
    }
  